<template>
  <Modal :id="'cmp-add-invoice_project'" @cancelled="onCancel">
    <template slot="header">{{$t('create_invoice_project')}}</template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'invoice_project_name'"
          required
          v-bind="textFieldConfig"
          v-model="invoice_project_name"
          isModel
          :placeholder="$t('invoice_project_name')"
          :autocomplete="'off'"
        />
        <DTCheckbox
          style="margin-left: -10px;"
          :id="'royalty_flag'"
          :label="$t('royalty_layout')"
          :checked="royalty_flag"
          @click="onCheckBoxClicked"
          :minH="'42px'"
          :class="'ml0'"
        />
        <Dropdown
          :disabled ="disableCurrency"
          :options="currenciesTV || []"
          :selected="selectedCurrency"
          class="m2"
          :placeholder="$t('default_currency')"
          v-on:selectedChange="e => selectedCurrency = e"
          :listHeight="95"
          box
        />
        <Dropdown
          :options="invoice_projectsTV || []"
          :selected="selectedInvoiceProject"
          class="m2"
          :placeholder="$t('copy_layout_from')"
          v-on:selectedChange="e => selectedInvoiceProject = e"
          :listHeight="95"
          box
        />
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 with-ico s6" @click.stop="onAddInvoiceProject">
        <div class="dt-icon-container">
          <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
        </div>
        <div class="button-text">{{$t('add_new')}}</div>
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { mapGetters } from "vuex";
import { InvoiceProjectService } from "../../services/invoice-project.service";
import { createCurrencyTV } from "../../../../models/currency.model";
import { createInvoiceProjectTV } from "../../../../models/invoice-project.model";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";

export default {
  components: {
    Modal,
    DTCheckbox,
  },
  mounted: async function() {
    const invoiceProjectFormData = await InvoiceProjectService.findInvoiceProjectSetup();
    this.invoiceProjectFormData = invoiceProjectFormData.data;
    console.log(invoiceProjectFormData.data);
  },
  data: function() {
    return {
      invoice_project_name: "",
      password: "",
      email: "",

      selectedInvoiceProject: null,
      selectedCurrency: null,
      royalty_flag:false,
      invoiceProjectFormData: null,
      disableCurrency:false,
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      }
      // Mark: Data
    };
  },
  watch: {
    systemLanguagesTV: {
      immediate: true,
      handler: function(to, from) {
        if (to) {
          this.selectedLanguage = to[0];
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      systemLanguagesTV: "systemLanguagesTV"
    }),
    invoice_project: function() {
      return {
        invoice_project_name: this.invoice_project_name,
        default_currency_id: this.selectedCurrency.value,
        copy_invoice_project_id: this.selectedInvoiceProject.value,
        royalty_flag: this.royalty_flag ? '1' : '0',
      };
    },
    currenciesTV: function() {
      return this.invoiceProjectFormData ? createCurrencyTV(this.invoiceProjectFormData.currencies) : [];
    },
    invoice_projectsTV: function() {
      return this.invoiceProjectFormData ? createInvoiceProjectTV(this.invoiceProjectFormData.invoice_projects) : [];
    }
  },
  methods: {
    onCheckBoxClicked: function (event) {
      this.royalty_flag = event.target.checked?1:0;
      this.disableCurrency = event.target.checked;
      console.log("::::",this.selectedCurrency)
      if(this.disableCurrency){

        this.selectedCurrency = { color: undefined , selected:undefined ,text:"EUR" , value:1}
      }
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onAddInvoiceProject: async function() {
      const newInvoiceProject = await InvoiceProjectService.insertInvoiceProject({
        ...this.invoice_project
      });
      const invoiceProjects = await InvoiceProjectService.findInvoiceProjects2();

      this.$emit("added", {
        invoice_projects: invoiceProjects.data.invoice_projects,
        new_invoice_project_id: newInvoiceProject.data.invoice_project_id
      });
    }
    // Mark: Methods
  }
};
</script>

<style lang="scss" scoped>
</style>
